import useSWR from 'swr';
import { IComplianceInfo } from '../../../interface/ComplianceInterface';
import { useState } from 'react';
import { endpoints } from '../../../utils/URL';
import { useHistory } from 'react-router-dom';
import fetcher from '../../../utils/axiosFetcher';
import { ConfirmationDialog } from '../../common/ConfirmationDialog';

const CheckCompliance = () => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);

  const url = `${endpoints.compliance.mainUrl}`;

  const { data, isLoading } = useSWR<IComplianceInfo>(url, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    onError: (error: any) => {
      console.error('Error fetching compliance data:', error);
    },
    onSuccess: (data: IComplianceInfo) => {
      //if data is null or properties of data is null or empty, navigate to compliance page
      if (
        !data ||
        !data.complianceDocuments?.cacCertificate ||
        !data.complianceDocuments?.psnCertificate ||
        !data.cacNumber
      ) {
        setModalOpen(true);
      }
    },
  });
  //check if the compliance is complete

  return (
    <section>
      {!isLoading && data && (
        <ConfirmationDialog
          open={modalOpen}
          close={() => setModalOpen(false)}
          message='Your compliance information is not complete. Please complete your compliance to enjoy all the benefits of Wellapartner.'
          title='Compliance Update Required'
          iconClass='bi bi-exclamation-triangle-fill text-danger'
          okText='Go'
          cancelText='Remind me later'
          showButtons={true}
          keepOpen={true}
          onConfirm={() => {
            setModalOpen(false);
            history.push('/onboarding/compliance');
          }}
        />
      )}
    </section>
  );
};

export default CheckCompliance;
